import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { RecommendedSpaceBannerProps } from '../src/RecommendedSpaceBanner.tsx';

export const RecommendedSpaceBannerLoader: LoadableType<RecommendedSpaceBannerProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-RecommendedSpaceBanner" */ '../src/RecommendedSpaceBanner.tsx'
				)
			).RecommendedSpaceBanner,
	});
